import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import NiceModal from "@ebay/nice-modal-react";
import ArrowButton from "../ArrowButton";
import AwardCard from "../AwardCard";
import ActivityCard from "../ActivityCard";
import AppVideoCard from "../AppVideoCard";
import PrizeCard from "../PrizeCard";
import "./style.scss";

import "swiper/css";
import "swiper/css/navigation";

export default function AppPrizeSlider({ prizesToRender = [] }) {
  return (
    <div className="ultra-insider-slider-app">
      <div className="slider">
        <div className="cta-group">
          <div className="swiper-button-prev app-prize">
            <ArrowButton reverse />
          </div>
          <div className="swiper-button-next app-prize">
            <ArrowButton />
          </div>
        </div>
        <Swiper
          className="premiumSwiper-app-prize"
          modules={[Navigation]}
          spaceBetween={28}
          slidesPerView={1.1}
          navigation={{
            nextEl: ".swiper-button-next.app-prize",
            prevEl: ".swiper-button-prev.app-prize",
          }}
          breakpoints={{
            720: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },
          }}
        >
          {prizesToRender.map((e, idx) => {
            if (e.ident === "app-video-placeholder") {
              return (
                <SwiperSlide key={idx}>
                  <AppVideoCard
                    mobileImg={e?.thumbnail?.file?.url}
                    desktopImg={e?.hero_image?.file?.url}
                    imgDesc={e?.hero_image?.metadata?.imgDesc}
                    copy={e?.content?.title}
                    points={e.payout}
                    brands={e.brands}
                    completed={e.completed}
                    ident={e.ident}
                    type={e.type}
                    highlighted={e.highlighted}
                    disabled={e.disabled}
                    date={e?.date}
                    description={e.description || ""}
                  />
                </SwiperSlide>
              );
            }
            if (e.ident === "app-coupon-placeholder") {
              return (
                <SwiperSlide key={idx}>
                  <ActivityCard
                    className="app-coupon-placeholder"
                    mobileImg={e?.thumbnail?.file?.url}
                    desktopImg={e?.hero_image?.file?.url}
                    imgDesc={e?.hero_image?.metadata?.imgDesc}
                    copy={e?.content?.title}
                    points={e.payout}
                    brands={e.brands}
                    completed={e.completed}
                    ident={e.ident}
                    type={e.type}
                    highlighted={e.highlighted}
                    disabled={e.disabled}
                    date={e?.date}
                    description={e.description || ""}
                    onClick={(ev) => ev.preventDefault()}
                  />
                </SwiperSlide>
              );
            }
            if (e.ident === "app-download-app-placeholder") {
              return (
                <SwiperSlide key={idx}>
                  <PrizeCard
                    buttonCopy={e.buttonCopy}
                    brands={e.brands}
                    copy={e.content?.title}
                    mobileImg={e.thumbnail?.file?.url}
                    desktopImg={e.hero_image?.file?.url}
                    imgDesc={e.hero_image?.metadata?.imgDesc}
                    highlighted={e.highlighted}
                    points={e.price}
                    key={idx}
                    availableForStatus={e.hasLevel}
                    ident={e.ident}
                    level={e.level}
                    inStock={e.inStock}
                    hasPoints={e.hasPoints}
                    hasLevel={e.hasLevel}
                    partner={e.partner}
                    completed={e.completed || false}
                    href={e.ident}
                    date={e.date || null}
                    description={e.content?.description || ""}
                    disabled={e.disabled || false}
                    list={e.list || false}
                    appBadge={e.appBadge}
                    ios={e.ultraInsiderRedemption?.includes("ios")}
                    to="/ultra-insider/ultra-care?slider=true"
                  />
                </SwiperSlide>
              );
            }
            const isIos = e.ultraInsiderRedemption?.includes("ios");

            return (
              <SwiperSlide key={idx}>
                <AwardCard
                  brands={e.brands}
                  copy={e.content?.title}
                  mobileImg={e.thumbnail?.file?.url}
                  desktopImg={e.hero_image?.file?.url}
                  imgDesc={e.hero_image?.metadata?.imgDesc}
                  highlighted={e.highlighted}
                  points={e.price}
                  key={idx}
                  availableForStatus={e.hasLevel}
                  ident={e.ident}
                  level={e.level}
                  inStock={e.inStock}
                  hasPoints={e.hasPoints}
                  hasLevel={e.hasLevel}
                  partner={e.partner}
                  availabilityLevel={e.availabilityLevel}
                  completed={e.completed || false}
                  href="#"
                  date={e.date || null}
                  description={e.content?.description || ""}
                  disabled={e.disabled || false}
                  list={e.list || false}
                  appBadge={e.appBadge}
                  ios={isIos}
                  onClick={(ev) => {
                    ev.preventDefault();
                    NiceModal.show("download-app-modal", {
                      platform: isIos ? "ios" : "android",
                    });
                  }}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
